export default __webpack_public_path__ + "static/media/Fire_Long_V2.a57c3381.png";